import { render } from "./DropdownMenu.vue?vue&type=template&id=ca62ddba"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"
script.render = render

export default script